var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"informationDetails"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"arcTitle"},[_vm._v(_vm._s(_vm.cdata.title))]),_c('div',{staticClass:"contentBox",domProps:{"innerHTML":_vm._s(_vm.cdata.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }